import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-create-api-key',
  templateUrl: './create-api-key.component.html',
  styleUrls: ['./create-api-key.component.scss']
})
export class CreateApiKeyComponent {
  singleTransaction: any;
  fetchingTransaction: boolean = true;
  userDetails: any = {};
  isLoading: boolean = false;
  fetchingData: boolean = false;
  errorMessage: string = "";
  @Input() visible: boolean = false;
  @Input() randomNumber: string = "";
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter();


  constructor(
  ){
    // console.log(this.visible)
  }
  ngOnChanges() {
    // this.getSingleTransaction();
  }

  async ngOnInit(){
    this.fetchingTransaction = true;
  }
  handleCancel() {
    this.visible = false;
    this.visibleChange.emit(this.visible);
  }

}
